import { AxiosRequestConfig } from 'axios'
import { UseQueryOptions } from 'react-query'

import useAuth from 'hooks/use-auth'
import { useGremlinQuery } from 'hooks/use-gremlin-query'
import { UserInfo } from 'types/api/companies/users'
import { companiesIdUsersGet } from 'utils/endpoints-access'
import { ms } from 'utils/time/millisecond'

// TODO support for react-query's useMutation here so we don't have to pass around refetch() functions

const QUERY_KEY_BASE_COMPANY_USERS = 'COMPANY_USERS'

export const companyUsersQueryKeys = {
  all: [QUERY_KEY_BASE_COMPANY_USERS]
}

export function useGetCompanyUsers(
  axiosRequestOptions: AxiosRequestConfig = {},
  queryOptions?: UseQueryOptions<UserInfo[]>
) {
  const { companyId, hasEndpointAccess } = useAuth()
  const canReadAllUsers = hasEndpointAccess(companiesIdUsersGet)

  const requestStatus = useGremlinQuery<UserInfo[]>(
    `/companies/${companyId}/users`,
    axiosRequestOptions,
    {
      staleTime: ms.minutes(5),
      ...queryOptions,
      enabled: canReadAllUsers,
      placeholderData: [],
      queryKey: companyUsersQueryKeys.all
    }
  )

  return requestStatus
}
